var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIco12345Warning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "104px",
    height: "118px",
    viewBox: "0 0 104 118",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 26\u5907\u4EFD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M32,0 C49.673112,0 64,14.360362 64,32.0747664 C64,41.7358195 59.7386452,50.3992543 52.9971751,56.2796696 L32.0500895,78 L11.048967,56.3198412 C4.28080533,50.4387475 0,41.7578428 0,32.0747664 C0,14.360362 14.326888,0 32,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-53.1%",
    y: "-33.3%",
    width: "206.2%",
    height: "187.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 8,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-37.5%",
    y: "-37.5%",
    width: "175.0%",
    height: "175.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u65B0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7AD9\\u70B9\\u5730\\u56FE3\\u5907\\u4EFD",
    transform: "translate(-265.000000, -1484.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-26\\u5907\\u4EFD",
    transform: "translate(285.000000, 1496.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5F62\\u72B6\\u7ED3\\u5408"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F25643",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u6848\\u4EF6\\u5BA1\\u6838",
    filter: "url(#filter-3)",
    transform: "translate(16.000000, 15.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5454545,5 L28,5 L28,30 L4,30 L4,5 L9.45454545,5 L9.45454545,7.17391304 L22.5454545,7.17391304 L22.5454545,5 Z M9.57067592,16.4737493 L8,18.0010606 L14.1778463,24 L25,13.4912498 L23.462092,12 L14.1778463,20.9835602 L9.57067592,16.4737493 Z M12,5 L12,2 L21,2 L21,5 L12,5 Z",
    id: "\\u5F62\\u72B6",
    fill: "#FFFFFF"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco12345Warning);
export default __webpack_public_path__ + "static/media/ico_12345_warning.e8ea39b17ab25f1a918eacebe16c7c77.svg";
export { ForwardRef as ReactComponent };